import { motion } from "framer-motion";

let counter = 0;

export default function XionLogo({
  size = 32,
  withText = false,
  animated = false,
  className = "",
}) {
  const uid = `xlogo-${++counter}`;
  const Wrap = animated ? motion.svg : "svg";
  const wrapProps = animated
    ? { initial: { scale: 0.9, opacity: 0 }, animate: { scale: 1, opacity: 1 }, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } }
    : {};

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {/* ── X mark (matches logo image 2) ─────────────────────────── */}
      <Wrap
        viewBox="0 0 100 100"
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Xion logo mark"
        style={{ display: "block", flexShrink: 0 }}
        {...wrapProps}
      >
        <defs>
          {/* Main brand gradient: cyan top-left → blue → purple bottom-right */}
          <linearGradient id={`${uid}-main`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%"   stopColor="#00D4FF" />
            <stop offset="48%"  stopColor="#2060EE" />
            <stop offset="100%" stopColor="#8B2FE8" />
          </linearGradient>
          {/* Reverse gradient for second stroke */}
          <linearGradient id={`${uid}-rev`} x1="100%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%"   stopColor="#00D4FF" />
            <stop offset="48%"  stopColor="#2060EE" />
            <stop offset="100%" stopColor="#8B2FE8" />
          </linearGradient>
          <filter id={`${uid}-glow`} x="-30%" y="-30%" width="160%" height="160%">
            <feGaussianBlur stdDeviation="1.8" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* Top-left → bottom-right diagonal (with notch at center) */}
        <polygon
          points="10,4 30,4 56,44 80,4 100,4 68,52 100,96 80,96 56,60 30,96 10,96 44,52"
          fill={`url(#${uid}-main)`}
          filter={`url(#${uid}-glow)`}
        />
      </Wrap>

      {/* ── Wordmark ───────────────────────────────────────────────── */}
      {withText && (
        <span className="flex flex-col leading-none select-none">
          <span
            className="font-display font-black tracking-tight text-[#0E0E1A]"
            style={{ fontSize: size * 0.58, letterSpacing: "-0.02em" }}
          >
            XION
          </span>
          <span
            className="font-mono uppercase tracking-[0.22em]"
            style={{
              fontSize: size * 0.22,
              background: "linear-gradient(90deg, #00D4FF, #2060EE)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            LABS
          </span>
        </span>
      )}
    </span>
  );
}
